import { defaultRuleRegistry } from '../rules/registry';
import type { Diagnostic, RuleEvaluationContext } from '../types';

import { normalizeFromRemoteControlUI } from './normalizers';
import { runRules } from './ruleRunner';

/**
 * Runs the rule registry against a routine and returns blocking diagnostics
 * (errors only — warnings are excluded by default). Pure pipeline: takes a
 * fully-formed `RuleEvaluationContext`, does no synthesis. The cascade-aware
 * wrapper lives in `precheckForExecution`.
 *
 * Splitting this from `precheckForExecution` makes the cascade's recursion
 * termination structural rather than conventional: the cascade calls into
 * `runValidation` (no cascade branch), so it cannot re-enter itself.
 */
export function runValidation(
  routine: unknown,
  ctx: RuleEvaluationContext,
): { ok: true } | { ok: false; errors: Diagnostic[] } {
  const routineView = normalizeFromRemoteControlUI(
    routine as Parameters<typeof normalizeFromRemoteControlUI>[0],
  );

  const errors = runRules(defaultRuleRegistry, routineView, ctx);

  const blockingErrors = errors.filter((e) => e.severity !== 'warning');

  return blockingErrors.length
    ? { ok: false, errors: blockingErrors }
    : { ok: true };
}
